import { FragmentType, getFragmentData } from "@/souhl_admin/gql/__generated__"
import { graphql } from "@/souhl_admin/gql/__generated__/gql"

export const KnownIssueDaySummaryFragment = graphql(/* GraphQL */ `
	fragment KnownIssueDaySummaryFragment on KnownIssueDaySummary {
		date
		matchLogCount
		sampleReqId
		sampleMessage
	}
`)

export type KnownIssueDaySummary = {
	date: string
	matchLogCount: number
	sampleReqId?: string | null
	sampleMessage?: string | null
}

export type DaySummaryEntry = {
	daySummaries: FragmentType<typeof KnownIssueDaySummaryFragment>[]
	last24HoursMatchCount: number
}

export type DaySummariesByIssueId = Map<string, DaySummaryEntry>

/**
 * Fragment data を KnownIssueDaySummary 型に変換
 */
export const toKnownIssueDaySummary = (
	fragment: FragmentType<typeof KnownIssueDaySummaryFragment>
): KnownIssueDaySummary => {
	return getFragmentData(KnownIssueDaySummaryFragment, fragment)
}
